import { useLocation } from '@tanstack/react-router';
export function useIsIndividual(): boolean {
  const location = useLocation();
  return location.pathname.startsWith('/individual');
}